import { track as customTrack } from '@amplitude/analytics-browser';
import Cookies from 'js-cookie';
import { hasStatisticsConsent } from 'utils/helpers/cookiebot';

/*
Every Amplitude event in the app goes through here, so this is the guard that
actually holds: a missing, declined or revoked statistics consent stops all of
utils/helpers/amplitude.ts, even where a component tracks before App has
re-synced with Cookiebot.
*/
const track = (eventName: string, eventData: object) => {
  const loggedEventName = eventName.slice(0, 100);
  if (!hasStatisticsConsent()) {
    console.log(`[Amplitude] event dropped (no statistics consent): ${loggedEventName}`);
    return false;
  }
  const isBotUser = Cookies.get('isBotUser') === 'true';
  const urlParams = new URLSearchParams(window.location.search);
  const isTrackingOff = urlParams.get('track') === 'off';
  if (isBotUser || isTrackingOff) {
    console.log(
      `[Amplitude] event dropped (${isBotUser ? 'bot user' : 'track=off'}): ${loggedEventName}`
    );
    return false;
  }
  console.log(`[Amplitude] track: ${loggedEventName}`);
  return customTrack(eventName, eventData);
};

export default track;
